<template>
  <div class="top">
    <div class="logo-box">
      <img class="logo" alt="长留香" src="../assets/logo.png"/>
    </div>
    <div class="nav" @click="chooseHandler">
      <span :class="indexId === '0' ? 'nav-color' : ''" id="0">首页</span>
      <span :class="indexId === '1' ? 'nav-color' : ''" id="1">关于长留香</span>
      <span :class="indexId === '2' ? 'nav-color' : ''" id="2">产品中心</span>
      <span :class="indexId === '3' ? 'nav-color' : ''" id="3">联系我们</span>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, watch } from 'vue'
import router from '@/router/index.js'
import { useRoute } from 'vue-router'

export default defineComponent({
  name: 'TopNav',
  setup () {
    const indexId = ref('0')
    const route = useRoute()
    const state = reactive({
      path: ['/', '/about', '/product', '/contact']
    })
    watch(
      () => route.path,
      (val) => {
        state.path.forEach((element, index) => {
          if (val === element) {
            indexId.value = index + ''
          }
        })
      }
    )

    function chooseHandler (e) {
      if (indexId.value === e.target.id) {
        window.location.href = window.origin + state.path[e.target.id]
      } else {
        indexId.value = e.target.id
        switch (e.target.id) {
          case '0':
            router.push('/')
            break
          case '1':
            router.push('/about')
            break
          case '2':
            router.push('/product')
            break
          case '3':
            router.push('/contact')
            break
          default:
            break
        }
      }
    }

    return {
      indexId,
      chooseHandler
    }
  }
})
</script>

<style lang="scss" scoped>
@mixin wh($width, $height) {
  width: $width;
  height: $height;
}

@mixin font($size, $weight, $color) {
  font-size: $size;
  color: $color;
  font-weight: $weight;
}

.top {
  width: 100%;
  height: 1rem;
  position: fixed;
  overflow: hidden;
  top: 0;
  background-color: #DDD0BC;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  border-bottom: #2b324e solid 0.02rem;

  .logo-box {
    margin-right: 2.3rem;

    .logo {
      @include wh(1.505rem, 0.5rem);
    }
  }

  .nav {
    & span {
      @include font(0.18rem, 400, #2b324e);
      padding: 0.1rem 0.2rem;
      cursor: pointer; /*鼠标变小手*/
    }

    .nav-color {
      color: #2b324e;
      font-weight: bold;
      border-top: 0.01rem solid #2b324e;
    }
  }
}
</style>
